import { useEffect, useState } from 'react';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Alert, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { KpiBenchmarks } from 'benchmarking-domain/kpi-benchmark';
import { KpiCategory, KpiDefinition } from 'benchmarking-domain/kpi-definition';
import { KpiStatistics, KpiValues } from 'benchmarking-domain/kpi-value';
import { PlantKpiHistory } from 'benchmarking-domain/plant-kpi-history';
import Project from 'benchmarking-domain/project';

import { KpiChartItem } from './kpi-chart-item';
import KpiDetails from './kpi-details';
import KpiHeatmap from './kpi-heatmap';
import { KpiStructureViewType } from './kpi-viewer';

interface KpiCategoryViewProps {
  project: Project;
  scopeKpiValues: KpiValues | undefined;
  kpiCategory: KpiCategory | null;
  viewType: KpiStructureViewType;
  benchmarks: KpiBenchmarks | undefined;
  statistics?: Map<string, KpiStatistics> | undefined;
  historyItems?: Map<string, PlantKpiHistory> | undefined;
}

const KpiCategoryView: React.FC<KpiCategoryViewProps> = ({
  project,
  scopeKpiValues,
  kpiCategory,
  viewType,
  benchmarks,
  statistics,
  historyItems,
}) => {
  const [kpiDefinitions, setKpiDefinitions] = useState<KpiDefinition[]>([]);

  useEffect(() => {
    if (!kpiCategory?.kpiDefinitions) {
      return;
    }

    setKpiDefinitions(kpiCategory.kpiDefinitions);
  }, [kpiCategory]);

  if (!kpiCategory?.kpiDefinitions || kpiCategory.kpiDefinitions.length === 0) {
    return (
      <Alert severity="info">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>Select a node with the</Typography>
          <BarChartIcon sx={{ mx: 0.5, color: '#A9C472' }} />
          <Typography>icon to view KPIs</Typography>
        </Box>
      </Alert>
    );
  }

  return (
    <>
      {viewType === KpiStructureViewType.DetailedCharts ? (
        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ width: '100%' }}>
          {kpiDefinitions.map((kpi, index) => (
            <Grid key={'category' + index + kpi.name} xs={12} lg={6}>
              <KpiChartItem>
                <KpiDetails
                  project={project}
                  scopeKpiValues={scopeKpiValues}
                  kpi={kpi}
                  benchmarks={benchmarks}
                  statistics={statistics}
                  historyItems={historyItems}
                />
              </KpiChartItem>
            </Grid>
          ))}
        </Grid>
      ) : (
        <KpiHeatmap
          category={kpiCategory}
          scopeKpiValues={scopeKpiValues}
          benchmarks={benchmarks}
          statistics={statistics}
          plantId={project.plantId}
        />
      )}
    </>
  );
};

export default KpiCategoryView;
